import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-account-extend',
  templateUrl: './extend.component.html',
  styleUrls: ['./extend.component.scss']
})
export class ExtendComponent implements OnInit {

  loading = false;
  notice:any;


  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) {
    //console.log(okService.billing);
  }

  ngOnInit(): void {


  }


  extend(){

    this.loading = true;
    this.notice= null;

        this.okService.post("billing/extend",{})
        .subscribe((data) => {

          this.loading = false;

          let response:any = data.body;

          this.notice = response;

          if(this.notice.success){

            //console.log("Update the billing");

            this.okService.get("billing",{})
            .subscribe((data:any) => {

              
              this.okService.billing = data.body;

              //console.log(this.okService.billing);

              this.router.navigateByUrl('/account');

              this.okService.setAlert(this.notice.message,"success");

            })

          }
          
        })
      }
}
